import store from './store/layout';

export default {
    install(Vue) {
        Vue.$store.registerModule('Layout', store);
    },
};
